import React from 'react'
import './Slider.scss'
import svg from '../../assets/game1.png'
import svg1 from '../../assets/biggame.png'
import svg2 from '../../assets/space.png'
import svg3 from '../../assets/ecogame.png'
import svg4 from '../../assets/game2.png'

const Slider = () => {
  return (
    <div className='slider-track'>
        <main className='slider'>
            <div className="slide-track">
                <div className="slide grid-item-1">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg1} alt='' />
                </div>
                <div className="slide grid-item-2">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg} alt='' />
                </div>
                <div className="slide grid-item-3">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg2} alt='' />
                </div>
                <div className="slide grid-item-4">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg3} alt='' />
                </div>
                <div className="slide grid-item-5">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg4} alt='' />
                </div>
            </div>
            <div className="slide-track">
                <div className="slide grid-item-1">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg1} alt='' />
                </div>
                <div className="slide grid-item-2">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg} alt='' />
                </div>
                <div className="slide grid-item-3">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg2} alt='' />
                </div>
                <div className="slide grid-item-4">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg3} alt='' />
                </div>
                <div className="slide grid-item-5">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg4} alt='' />
                </div>
            </div>
            <div className="slide-track">
                <div className="slide grid-item-1">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg1} alt='' />
                </div>
                <div className="slide grid-item-2">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg} alt='' />
                </div>
                <div className="slide grid-item-3">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg2} alt='' />
                </div>
                <div className="slide grid-item-4">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg3} alt='' />
                </div>
                <div className="slide grid-item-5">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg4} alt='' />
                </div>
            </div>
            <div className="slide-track">
                <div className="slide grid-item-1">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg1} alt='' />
                </div>
                <div className="slide grid-item-2">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg} alt='' />
                </div>
                <div className="slide grid-item-3">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg2} alt='' />
                </div>
                <div className="slide grid-item-4">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg3} alt='' />
                </div>
                <div className="slide grid-item-5">
                {/* top row 1st item 2cols, 2nd item with 3/4 of top row, 3rd & 4th items of second row equal of 1st item, 5th item below 2nd item */}
                    <img src={svg4} alt='' />
                </div>
            </div>
        </main>
    </div>
  )
}

export default Slider